import { CAService as caAxios } from '@/utils/axios'

const api = {
  getQRCodeContent: '/loginController/getQRCodeContent', // 获取CA登录二维码图片
  getQRCodeIsScaned: '/loginController/getQRCodeIsScaned', // 获取扫码状态
  getQRCodeLoginInfo: '/loginController/getQRCodeLoginInfo' // 获取用户信息
}

/**
 * 获取CA登录二维码图片
 * @param {String} platformCode 平台编码
 * @returns
 */
export async function getQRCodeContent (platformCode = 'A3401314520') {
  const formData = new FormData()
  formData.append('platformCode', platformCode)
  return caAxios({
    url: api.getQRCodeContent,
    method: 'post',
    data: formData
  })
}

/**
 * 获取扫码状态
 * @param {String} tId 获取CA登录二维码图片接口返回的tid
 * @returns
 */
export function getQRCodeIsScaned (tId) {
  return caAxios({
    url: api.getQRCodeIsScaned,
    method: 'get',
    params: {
      tId
    }
  })
}

/**
 * 获取用户信息
 * @param {String} tId 获取CA登录二维码图片接口返回的tid
 * @returns
 */
export function getQRCodeLoginInfo (tId) {
  return caAxios({
    url: api.getQRCodeLoginInfo,
    method: 'get',
    params: {
      tId
    }
  })
}
